
import Title from "@/components/style/Title.vue";

export default {
  components: {Title},
  props: {
    airports: {},
    label: {default: false}
  }
}
